import { selectSession } from 'core/selectors/product/session';
import { ISessionReducer } from 'core/slices/session';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Role } from 'types/domain/role';

export function useIsAdmin() {
  const session: ISessionReducer = useSelector(selectSession);
  return [Role.AUTHOR, Role.ADMIN, Role.SUPER_ADMIN].includes(session.role) && session.jwt;
}

/**
 * Admin proper, as opposed to `useIsAdmin`, which is "may reach the admin
 * console at all" and includes authors.
 *
 * Managing who has platform access is an admin's job — an author can build
 * courses without being able to grant anyone else access.
 */
export function useIsOrgAdmin() {
  const session: ISessionReducer = useSelector(selectSession);
  return [Role.ADMIN, Role.SUPER_ADMIN].includes(session.role) && session.jwt;
}

export function useIsSuperAdmin() {
  const session: ISessionReducer = useSelector(selectSession);
  return [Role.SUPER_ADMIN].includes(session.role) && session.jwt;
}
